// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "  \r\n.spinnerInner {\r\n    margin-left: 1rem;\r\n    margin-bottom: -.3rem;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/components/Loading/LoadingInner/index.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,qBAAqB;AACzB","sourcesContent":["  \r\n.spinnerInner {\r\n    margin-left: 1rem;\r\n    margin-bottom: -.3rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
